import { useBemCN } from '@gik/core/utils/bemBlock';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import { Button } from '@gik/ui/Button';
import { SvgIcon } from '@gik/ui/SvgIcon';
import PaperAirplaneIcon from '@heroicons/react/solid/PaperAirplaneIcon';
import React from 'react';
import { UserAvatar } from '../../../ui/gik/UserAvatar';
import type { CommentInputProps } from './CommentInput';
import { CommentInput } from './CommentInput';

type StreamWrapperProps = {
  onClick?: () => void;
};

export type CommentInputWithAvatarProps = {
  onClick?: () => void;
  onSubmit?: (forId: string, value: string) => void;
  escapeMessage?: boolean;
  submitButton?: boolean;
} & CommentInputProps;

function CommentInputWithAvatarComp({
  className,
  onClick,

  onSubmit,
  forId,
  value,
  escapeMessage,
  submitButton,
  ...otherProps
}: React.PropsWithChildren<CommentInputWithAvatarProps>): React.ReactElement {
  const bem = useBemCN('comment-input-avatar');

  const handleClickSubmit = React.useCallback(() => {
    onSubmit(forId, value);
  }, [forId, value, onSubmit]);

  return (
    <div {...bem(null, null, className)} onClick={onClick}>
      <UserAvatar />
      <div {...bem('input-wrapper')}>
        <CommentInput {...otherProps} value={value} forId={forId} onSubmit={onSubmit} />
        {escapeMessage && <span {...bem('input-message')}>Press esc to cancel</span>}
      </div>
      {submitButton && (
        <div {...bem('actions')}>
          <Button circle disabled={!value?.length} onClick={handleClickSubmit} {...bem('btn_submit')}>
            <SvgIcon Icon={PaperAirplaneIcon} />
          </Button>
        </div>
      )}
    </div>
  );
}

export const CommentInputWithAvatar = withComponentErrorBoundary(CommentInputWithAvatarComp);
